import {observable} from 'mobx';
import BaseStore from "./BaseStore";
import AggregationModel from "../models/AggregationModel";
import moment from "moment/moment";
import {action} from "mobx/lib/mobx";

export default class AggregationStore extends BaseStore{
  transportLayer;
  @observable loading = false;
  @observable aggregationMethods = [];
  @observable intervals = [];
  @observable filters = {
    series_id: null,
    date_from: moment().add(-6, 'days').format('YYYY-MM-DDT00:00:00'),
    date_to: moment().format('YYYY-MM-DDT00:00:00'),
  };

  constructor(transportLayer) {
    super(AggregationModel, transportLayer);
  }

  fetchAggregations(station_id){
    this.loading = true;
    this.transportLayer.fetchById(station_id).then(json => {
      this.loading = false;
      this.items = json;
    }).catch(err => {
      this.loading = false;
      console.error(err);
    });
  }

  fetchAggregationMethods(){
    this.transportLayer.fetchAggregationMethods().then(json => {
      this.aggregationMethods = json;
    });
  }

  createAggregationItem(json, station_id){
    return this._create(json)
      .then(() => {
        return this.fetchAggregations(station_id)
      })
  }

  updateAggregationItem(json){
    let payload = {
      id: +json.id,
      aggregation_method_id: +json.aggregation_method_id,
      source_series_id: +json.source_series_id,
      out_series_id: +json.out_series_id,
      interval: json.interval,
      use_suspicious: json.use_suspicious,
      starting_time: json.starting_time,
      enabled: json.enabled,
    };
    return this._update(json.id, payload)
      .then(() => {
        this.items.filter(item => item.id === json.id)[0] = json;
      })
  }

  fetchIntervals(){
    this.transportLayer.fetchAggregationIntervals().then(json => {
      this.intervals = json;
    })
  }

  @action onChangeSeries = (e) => this.filters.series_id = e.target.value;
  @action onChangeDateFrom = (e) => this.filters.date_from = e.target.value;
  @action onChangeDateTo = (e) => this.filters.date_to = e.target.value;

  @action resetFilters(){
    this.filters = {
      series_id: null,
      date_from: moment().add(-6, 'days').format('YYYY-MM-DDT00:00:00'),
      date_to: moment().format('YYYY-MM-DDT00:00:00'),
    }
  }

  runManualAggregation(filters){
    this.loading = true;
    return this.transportLayer.runManualAggregation(filters);
  }

};


// WEBPACK FOOTER //
// ./src/stores/AggregationStore.js